import { normalizeDatabaseShardManifest } from '@blocksuite/affine-model';

export type DatabaseSnapshotReadinessSource = {
  getLogicalRowIdsSnapshot: () => string[];
  storageModel?: { props?: Record<string, unknown> };
};

export function isDatabaseSnapshotFullyLoaded(
  dataSource: DatabaseSnapshotReadinessSource
): boolean {
  const manifest = normalizeDatabaseShardManifest(
    dataSource.storageModel?.props?.databaseShardManifest
  );
  if (!manifest) return true;

  const expectedRows = (manifest.shards ?? []).reduce(
    (sum, shard) =>
      sum + (typeof shard.rowCount === 'number' ? shard.rowCount : 0),
    0
  );
  if (expectedRows === 0) return true;

  try {
    return dataSource.getLogicalRowIdsSnapshot().length >= expectedRows;
  } catch {
    return false;
  }
}
